<template>
  <div class="rfjfgzas">
    <el-date-picker
      v-model="dateValue[0]"
      type="date"
      placeholder="开始日期"
      format="yyyy-MM-dd"
      style="width: 100px"
      :picker-options="pickerOptions1"
      @change="change">
    </el-date-picker>
    <span
      style="
        margin-left: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: var(--stock_area_item_color1);
      "
      >至</span
    >
    <el-date-picker
      v-model="dateValue[1]"
      type="date"
      placeholder="结束日期"
      format="yyyy-MM-dd"
      style="width: 100px"
      :picker-options="pickerOptions2"
      @change="change">
    </el-date-picker>
  </div>
</template>

<script>
import { debounce } from '@/utils';

export default {
  props: {
    value: Array,
  },
  computed: {
    dateValue: {
      get() {
        return this.value;
      },
      set(date) {
        this.$emit('input', date);
      },
    },
    pickerOptions1() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      };
    },
    pickerOptions2() {
      const o_time = this.value[0];
      const n_time = this.value[1];
      return {
        disabledDate(time) {
          const result = time.getTime() > Date.now();
          if (result) return result;
          if (o_time) {
            return time.getTime() < o_time.getTime();
          }
        },
      };
    },
  },
  methods: {
    change: debounce(function () {
      this.$emit('change', this.value);
    }, 600),
  },
};
</script>

<style scoped lang="less">
.rfjfgzas {
  /deep/.el-input__prefix,
  /deep/.el-input__suffix {
    display: none;
  }

  /deep/.el-input--prefix .el-input__inner {
    text-align: center;
    padding: 0 12px !important;
    border: none;
    color: var(--stock_area_item_color1);
    background-color: var(--Btn-bgc2);
  }
}
</style>
